import React from "react";

export default function RadarSweep({ size = 300 }) {
  return (
    <div
      aria-hidden="true"
      className="fixed pointer-events-none select-none z-0"
      style={{
        bottom: "-80px",
        right: "-80px",
        width: size,
        height: size,
        opacity: 0.16,
      }}
    >
      <svg
        viewBox="0 0 100 100"
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Concentric rings */}
        {[48, 36, 24, 12].map((r) => (
          <circle
            key={r}
            cx="50"
            cy="50"
            r={r}
            fill="none"
            stroke="rgba(0,232,122,0.22)"
            strokeWidth="0.4"
          />
        ))}

        {/* Cross hairs */}
        <line x1="50" y1="4"  x2="50" y2="96" stroke="rgba(0,232,122,0.18)" strokeWidth="0.3" />
        <line x1="4"  y1="50" x2="96" y2="50" stroke="rgba(0,232,122,0.18)" strokeWidth="0.3" />

        {/*
          Rotating sweep — uses the `radarRotate` keyframe defined in index.css.
          It is applied via inline style so it works without a Tailwind utility class.
        */}
        <g style={{ transformOrigin: "50px 50px", animation: "radarRotate 4s linear infinite" }}>
          <defs>
            <radialGradient id="sweepGradRdr" cx="50%" cy="50%" r="50%">
              <stop offset="0%"   stopColor="rgba(0,232,122,0)" />
              <stop offset="100%" stopColor="rgba(0,232,122,0.65)" />
            </radialGradient>
          </defs>
          {/* Sweep wedge */}
          <path
            d="M 50,50 L 50,2 A 48,48 0 0,1 82,18 Z"
            fill="url(#sweepGradRdr)"
          />
          {/* Leading edge line */}
          <line
            x1="50" y1="50" x2="50" y2="2"
            stroke="rgba(0,232,122,0.85)"
            strokeWidth="0.6"
          />
        </g>

        {/* Static decorative blips */}
        <circle cx="62" cy="28" r="1.2" fill="rgba(0,232,122,0.8)" />
        <circle cx="38" cy="65" r="0.9" fill="rgba(0,232,122,0.6)" />
        <circle cx="70" cy="55" r="1.1" fill="rgba(0,232,122,0.7)" />
        <circle cx="30" cy="35" r="0.8" fill="rgba(0,232,122,0.5)" />
        <circle cx="58" cy="72" r="0.7" fill="rgba(0,232,122,0.45)" />
      </svg>
    </div>
  );
}
